export const SUCCESS_MESSAGE = "SUCCESS_MESSAGE";
export const START_CREATING_ACCOUNT = "START_CREATING_ACCOUNT";
export const STOP_CREATING_ACCOUNT = "STOP_CREATING_ACCOUNT";
